export default __webpack_public_path__ + "static/media/yoga.ed789967.jpg";